import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  row: {
    margin: 5,
    display: "flex",
    alignItems: "center",
  },
  column: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "20px",
    borderRus: 4,
    background: "var(--app-surface-2)",
    marginTop: "20px",
    cursor: "pointer",
    // justifyContent: "space-between",
  },
  RowGridRadioParent: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    background: "var(--app-surface-2)",
    border: "1px solid var(--app-border)",
    borderRadius: "4px",
  },
  radioItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 5,
    width: 70,
    borderRadius: 4,
    height: 30,
    // background: "rgba(242, 242, 242, 1)",
    // border: "1px solid #E5E5E5",
    cursor: "pointer",
  },
  radioItemSelected: {
    cursor: "pointer",
    borderRadius: 4,
    display: "flex",
    gap: 5,
    justifyContent: "center",
    alignItems: "center",
    width: 70,
    height: 30,
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
  },
  radioImage: {
    height: 18,
  },

  // radio button group
  radioStartButton: {
    border: "none",
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: 20,
    background: "var(--app-surface-2)",
  },
  radioEndButton: {
    border: "none",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    background: "var(--app-surface-2)",
  },
  radioEndButtonSelected: {
    border: "none",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    background: "var(--app-tint-amber)",
  },
  radioStartButtonSelected: {
    border: "none",
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: 20,
    background: "var(--app-tint-amber)",
  },

  // folder item
  folderItem: {
    width: 200,
    margin: 10,
    padding: 10,
    position: "relative",
    borderRadius: 8,
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    "@media (max-width: 360px)": {
      width: "calc(100% - 20px)",
    },
  },

  disabledItem: {
    position: "relative",
    "&::after": {
      //content: '" "',
      position: "absolute",
      //cursor:'none',
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      //background: "rgba(0, 0, 0, 0.1)",
    },
  },

  verticalIconContainer: {
    position: "absolute",
    top: 5,
    right: 10,
  },
  folderDateText: {
    color: "var(--app-text-muted)",
    // marginTop: "3px",
  },
  expiryDateText: {
    color: "red",
  },
  folderMenuIcon: {
    width: 20,
  },
  folderBig: {
    width: 100,
  },
  fileImageRow: { width: 20, margin: 5 },
  actionsImageRow: { width: 20, cursor: "pointer" },

  filePreview: {
    marginTop: 5,
    background: "var(--app-surface-2)",
    padding: 10,
    borderRadius: 5,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // upload documents modal
  uploadModal: {
    "& .mantine-Modal-body": {
      padding: 0,
    },
  },
  uploadHeader: {
    background: "var(--app-primary)",
    padding: 10,
  },
  dropzone: {
    "& .mantine-Dropzone-root": {
      background: "var(--app-tint-amber)",
    },
    width: "80%",
    marginBottom: 20,
    "@media (max-width: 480px)": {
      width: "100%",
    },
  },
  modalHeaderImage: { width: 25 },
  dragImage: {
    alignSelf: "center",
    width: "35%",
  },
  browseText: {
    color: "rgba(107, 156, 255, 1)",
  },
  fileItem: {
    width: 250,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: 2,
    background: "var(--app-tint-amber)",
    padding: "13px 5px",
    margin: "5px",
    "@media (max-width: 360px)": {
      width: "calc(100% - 10px)",
    },
  },
  datePicker: {
    minWidth: 200,
    "& .mantine-InputWrapper-label": {
      marginLeft: 10,
    },
    "& .mantine-DatePickerInput-input": {
      borderRadius: 0,
      border: "1px solid var(--app-border)",
      borderBottom: "2px solid var(--app-primary)",
      background: "var(--app-surface-2)",
    },
  },

  // search bar
}));

export default useStyles;
